<template>
    <HeaderContent title="Schedule"/>
    <ActionContent ctaText="Add Schedule" @action="modal = !modal" :filterDate="false"/>
    <ScheduleStatistics title="Schedule Statistics" :data="statistics" />
    <ScheduleForm :modal="modal" @update:modal="modal = $event" />
    <ScheduleDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
</template>

<script>
import { ref } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import ScheduleForm from "./ScheduleForm.vue";
import ScheduleStatistics from "@/components/StatisticData.vue";
import ScheduleDataTable from "@/components/DataTable.vue";
import iconToday from '../../../../public/icons/sun.svg';
import iconWeek from '../../../../public/icons/week.svg';
import iconRoom from '../../../../public/icons/brand.svg';
import iconHousekeeping from '../../../../public/icons/hand-cleaning.svg';

export default {
    name: 'ScheduleIndex',
    components: {
        HeaderContent,
        ActionContent,
        ScheduleForm,
        ScheduleStatistics,
        ScheduleDataTable,
    },
    setup(){
        const modal = ref(false)
        const data = ref([
            {
                type_room: 'Deluxe',
                no_room: 'A3',
                housekeeping: 'Budi',
                // reservation_status: 'checkin',
            },
            {
                type_room: 'Super Deluxe',
                no_room: 'A1',
                housekeeping: 'Andi',
                // reservation_status: 'checkin',
            },
            {
                type_room: 'Honeymoon',
                no_room: 'A2',
                housekeeping: 'Rahmat',
                // reservation_status: 'checkin',
            },
            {
                type_room: 'Studio',
                no_room: 'A4',
                housekeeping: 'Siti',
                // reservation_status: 'checkin',
            },
            {
                type_room: 'Family',
                no_room: 'A5',
                housekeeping: 'Nur',
                // reservation_status: 'checkin',
            },
        ])
        const headers = ref([
            {
                key: 'type_room', label: 'Room Type', sortable: true,
            },
            {
                key: 'no_room', label: 'Room Number', sortable: true,
            },
            {
                key: 'housekeeping', label: 'Housekeeping Name', sortable: true,
            },
            {
                key: 'action', label: 'Actions'
            }
        ])

        const customActions = ref([
        {
            label: 'Reschedule',
            variant: 'warning',
            icon: 'fas fa-calendar-day',
            action: (item) => {
            console.log('Reschedule action clicked for:', item);
            // Implement your Reschedule logic here
            }
        },
        
        ]);
        const statistics = ref([
          {
            label: 'Total',
            key: 'Today',
            value: 3,
            color: 'primary',
            icon: iconToday
          },
          {
            label: 'Total',
            key: 'Week',
            value: 8,
            color: 'primary',
            icon: iconWeek
          },
          {
            label: 'Total',
            key: 'Room',
            value: 15,
            color: 'primary',
            icon: iconRoom
          },
          {
            label: 'Total',
            key: 'Housekeeping',
            value: 7,
            color: 'primary',
            icon: iconHousekeeping
          },
        ])

        return {
            modal,
            headers,
            statistics,
            customActions,
            data

        }
    }
}
</script>

<style>

</style>